import { useMutation, useQuery } from "react-query";

import axios from "../../../axios";
import { route } from "../../requests/routes";



export function useSellerTransectionQueue({ page, limit }){
    return useQuery(['seller_transection_queue', page, limit], async() => {
      const { data } = await axios.get(route.SELLER_TRANSECTION_QUEUE, {
        params:{
          page, limit
        }
      });
      return data;
    });
  }

export function useRiderTransectionQueue({ page, limit }){
  return useQuery([route.RIDER_TRANSECTION_QUEUE, page, limit], async() => {
    const { data } = await axios.get(route.RIDER_TRANSECTION_QUEUE, {
      params:{
        page, limit
      }
    });
    return data;
  });
}



export function useTransectionProcess(){
  return useMutation(async (payload) => {
    const { data } = await axios.post(route.TRANSECTION_PROCESS_MANUALLY, payload); 
    return data;
  })    
}